import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Allows access when the user is authenticated. Otherwise redirects to
 * /signin and preserves the attempted URL as `returnUrl`.
 *
 * Awaits `auth.whenReady()` first so that on a page reload, we let the
 * silent refresh complete before deciding — otherwise we'd flash /signin
 * on every reload even with a valid refresh token in localStorage.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (auth.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/signin'], {
    queryParams: { returnUrl: state.url },
  });
};
